import { render, staticRenderFns } from "./mem_block.vue?vue&type=template&id=2386a6e0&scoped=true&"
import script from "./mem_block.vue?vue&type=script&lang=js&"
export * from "./mem_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2386a6e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2386a6e0')) {
      api.createRecord('2386a6e0', component.options)
    } else {
      api.reload('2386a6e0', component.options)
    }
    module.hot.accept("./mem_block.vue?vue&type=template&id=2386a6e0&scoped=true&", function () {
      api.rerender('2386a6e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/mem_block.vue"
export default component.exports